<router-outlet></router-outlet>

<gg-version-renderer></gg-version-renderer>
